// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { AzSaldoDaten, type Benutzer } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateBenutzerAzsaldo(): (
  requestBody: AzSaldoDaten
) => Promise<Benutzer> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).benutzer.updateBenutzerAzsaldo({ requestBody }),
    [getAPI]
  );
}
